module.exports.API_ENDPOINT = process.env.API_ENDPOINT || "https://api.trtlogistics.com";
module.exports.DESTINATION_PORT = 2049;
module.exports.DEFAULT_LANG = "uk-uk";
